(function(){
  var STYLE_ID='plawny-hide-inpost-gesture-overlay';
  var timer=null;

  function onDeliveryPage(){
    return location.pathname.indexOf('/pages/wybor-dostawy')===0;
  }

  function getWidget(){
    return document.querySelector('[data-widget="inpost"] inpost-geowidget');
  }

  function getRoots(){
    var roots=[document];
    var widget=getWidget();
    try{
      if(widget && widget.shadowRoot) roots.push(widget.shadowRoot);
    }catch(e){}
    return roots;
  }

  function injectStyle(root){
    try{
      if(root.getElementById && root.getElementById(STYLE_ID)) return;
      var style=document.createElement('style');
      style.id=STYLE_ID;
      style.textContent='\n.leaflet-gesture-handling-warning,\n.leaflet-gesture-handling-scroll-warning,\n.leaflet-gesture-handling-touch-warning,\n[class*=gesture-handling],\n[class*=GestureHandling],\n[class*=gestureHandling]{display:none!important;opacity:0!important;visibility:hidden!important;pointer-events:none!important;}\n.leaflet-container.leaflet-gesture-handling-scroll-warning:before,\n.leaflet-container.leaflet-gesture-handling-scroll-warning:after,\n.leaflet-container.leaflet-gesture-handling-touch-warning:before,\n.leaflet-container.leaflet-gesture-handling-touch-warning:after{display:none!important;content:none!important;opacity:0!important;visibility:hidden!important;}\n';
      (root.head || root).appendChild(style);
    }catch(e){}
  }

  function hideTextNodes(root){
    try{
      root.querySelectorAll('div,span,p').forEach(function(el){
        var text=(el.textContent||'').trim().toLowerCase();
        var isCtrlText=(text.indexOf('naciśnij ctrl')>-1 || text.indexOf('nacisnij ctrl')>-1 || (text.indexOf('ctrl')>-1 && (text.indexOf('przewiń')>-1 || text.indexOf('przewin')>-1)));
        if(isCtrlText && text.length<220){
          el.style.setProperty('display','none','important');
          el.style.setProperty('opacity','0','important');
          el.style.setProperty('visibility','hidden','important');
          el.style.setProperty('pointer-events','none','important');
          var parent=el.parentElement;
          if(parent && parent.children.length<4){
            parent.style.setProperty('display','none','important');
            parent.style.setProperty('opacity','0','important');
            parent.style.setProperty('visibility','hidden','important');
            parent.style.setProperty('pointer-events','none','important');
          }
        }
      });
    }catch(e){}
  }

  function clean(){
    if(!onDeliveryPage()) return;
    getRoots().forEach(function(root){
      injectStyle(root);
      hideTextNodes(root);
    });
  }

  function start(){
    clean();
    clearInterval(timer);
    timer=setInterval(clean,500);
    setTimeout(clean,100);
    setTimeout(clean,600);
    setTimeout(clean,1500);
  }

  document.addEventListener('DOMContentLoaded',start);
  window.addEventListener('load',start);
  document.addEventListener('change',function(e){
    if(e.target && e.target.matches && e.target.matches('input[name="delivery-method"]')){
      setTimeout(start,100);
    }
  },true);
  document.addEventListener('click',function(){
    setTimeout(clean,50);
  },true);
  document.addEventListener('wheel',function(){
    setTimeout(clean,20);
  },{passive:true,capture:true});
})();